export const valoresExibidosOffCanvasEmpenhos: Record<string, string> = {
  id: 'ID',
  dataRegistro: 'Registro',
  dataAtualizacaoRegistro: 'Última Atualização',
  usuarioRegistro: 'Responsável pelo Registro',
  dataUltimaAtualizacao: 'Última Atualização',
  usuarioAtualizacao: 'Responsável Ult. Atualização',
  dataUltimaVisualizacao: 'Última Visualização',
  usuarioUltimaVisualizacao: 'Responsável Ult. Visualização',
  nEdicoes: 'Edições',
  nVisualizacoes: 'Visualizações',
  nVisualizadores: 'Visualizadores',
  observacoes: 'Observações',

  //Separadores
  separadorLog: '',
  separadorPontuacao: '',
  separadorIdentificacao: '',
  separadorFuncionalidade: '',
  separadorObservacoes: '',

  //Específicos
  interfaceSisAf: 'Interface',
  moduloSisAf: 'Módulo',
  tipoTask: 'Tipo de Task',
  responsavel: 'Responsável',
  dataEntrada: 'Data de Início',
  dataFinalizacao: 'Data Finalização',
  diasDev: 'Total de dias',
  funcionalidade: 'Funcionalidade',
  descricao: 'Descrição',
  complexidade: 'Complexidade',
  reaproveitamentoCodigo: 'Reaprov. Código',
  pontosFuncionalidade: 'Level (0 a 100)',
  statusDesenvolvimento: 'Status Dev',
  level: 'Level',
};

export const headersEmpenhos = [
  { text: '', width: 1, key: '' },
  { text: 'ID', width: 2, key: 'id' },
  { text: 'Status', width: 8, key: 'statusEmpenho' },
  { text: 'Comp. AF', width: 8, key: 'componenteAf' },
  { text: 'Nº SEI', width: 8, key: 'numeroSeiEmpenho' },
  { text: 'Nº Empenho', width: 8, key: 'numeroEmpenho' },
  { text: 'Solicitação', width: 5, key: 'dataSolicitacao' },
  { text: 'Data Empenho', width: 5, key: 'dataEmpenho' },
  { text: 'Contratos', width: 5, key: 'contratos' },
  { text: 'Parcelas', width: 5, key: 'parcelas' },
  { text: 'Valor Total R$', width: 15, key: 'valorTotal' },
];

export const fieldObjectEmpenhos = [
  'usuarioRegistro.nomeCompleto',
  'usuarioAtualizacao.nomeCompleto',
  'usuarioUltimaVisualizacao.nomeCompleto',
];
